/***
*
*   ACCOUNT
*   Index page for account functions
*
**********/

import React, { useContext } from 'react';
import { AuthContext, Animate, Users } from 'components/lib';
import AccountNav from './nav';

export function AccountUsers(props){

  const context = useContext(AuthContext);
  
  return (
    <Animate>
      {/* Profile Section */}
      

      { (context.permission?.owner || context.permission?.admin) &&
      <> 
      <AccountNav />
      <Users />
      </> 
      }
      
    </Animate>
  )
}